import moment from 'moment';
import { toast } from 'react-toastify';

export function fillEmptyMonths(
  closestDate: string,
  oldestDate: string,
  consumptions: Api.IDraxConsumptionData[] = []
) {
  const data: Api.IDraxConsumptionData[] = [...consumptions];

  const filledDates = new Set(
    consumptions.map(({ intervalStart }) => {
      const date = moment(intervalStart).startOf('month');

      return `${date.year()}/${date.month()}`;
    })
  );

  try {
    const closest = moment(closestDate);
    const oldest = moment(oldestDate);
    const diff = closest.diff(oldest, 'months');

    // If it's Monthly or Daily view we don't need to fill out
    if (diff <= 1) {
      return data;
    }
    for (let i = 0; i < diff; i += 1) {
      const current = moment(closest).startOf('month');
      const dateString = `${current.year()}/${current.month()}`;

      // If given month already contains data, don't add empty month
      if (!filledDates.has(dateString)) {
        data.push({
          totalConsumption: 0,
          intervalEnd: current.endOf('month').format('YYYY-MM-DDThh:mm:ss'),
          intervalStart: current.format('YYYY-MM-DDThh:mm:ss'),
          estimatedConsumption: 0,
          actualConsumption: 0,
          сonsumptionSource: 'HH',
        });
      }
      // Iterate through months from closest to oldest date
      closest.subtract(1, 'month');
    }
  } catch (error) {
    const message = 'Failed to fill up empty months, caught error.';

    console.error(message, error);
    toast.error(message);
  } finally {
    return data;
  }
}